import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderReportedByTypesAdapter = getAdapter({ idFieldName: 'value' });

const repairOrderReportedByTypesSlice = createSlice({
  name: 'repairOrderReportedByTypes',
  initialState: repairOrderReportedByTypesAdapter.getInitialState(),
  reducers: {
    setRepairOrderReportedByTypes: (state, { payload: { repairOrderReportedByTypes } }) => {
      repairOrderReportedByTypesAdapter.setAll(state, repairOrderReportedByTypes);
    },
  },
});

const selectors = repairOrderReportedByTypesAdapter.getSelectors(
  ({ repairOrderReportedByTypes }) => repairOrderReportedByTypes,
);

export const getRepairOrderReportedByTypes = (state) => selectors.selectAll(state);

export const { setRepairOrderReportedByTypes } = repairOrderReportedByTypesSlice.actions;

export default repairOrderReportedByTypesSlice.reducer;
